import { Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-navigator-panel',
  templateUrl: './navigator-panel.component.html'
})
export class NavigatorPanelComponent  {

  @Input()
  linkAltText: string;

  @Input()
  route: string;

  @Input()
  panelTitle: string;

  @Input()
  panelText: string;

  @Input()
  isMojoDashboard: boolean;


}
